import { PublicClientApplication, BrowserCacheLocation, LogLevel } from "@azure/msal-browser"
import { msalConfig } from "../AuthMicrosoft/authConfig" // Percorso corretto
import { devError, devLog, devWarn } from "../../utils/devConsole"

const isProd = process.env.NODE_ENV === "production"

const msalLoggerCallback = (level, message, containsPii) => {
  if (containsPii) return
  switch (level) {
    case LogLevel.Error:
      devError("[MSAL]", message)
      break
    case LogLevel.Warning:
      devWarn("[MSAL]", message)
      break
    case LogLevel.Info:
      devLog("[MSAL]", message)
      break
    default:
      devLog("[MSAL]", message)
      break
  }
}

// Configurazione migliorata per MSAL
const enhancedMsalConfig = {
  ...msalConfig,
  cache: {
    ...msalConfig.cache,
    cacheLocation: BrowserCacheLocation.SessionStorage,
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: isProd ? () => {} : msalLoggerCallback,
      piiLoggingEnabled: false,
      logLevel: isProd ? LogLevel.Error : LogLevel.Info,
    },
    windowHashTimeout: 60000, // Augmenter le timeout pour le traitement du hash
    iframeHashTimeout: 10000, // Timeout pour les iframes
    loadFrameTimeout: 10000, // Timeout pour le chargement des iframes
  },
}

// Create the MSAL instance
const msalInstance = new PublicClientApplication(enhancedMsalConfig)

// Rendere l'istanza accessibile globalmente per la disconnessione automatica
if (typeof window !== 'undefined') {
  window.msalInstance = msalInstance;
}

// Initialize MSAL
export const initializeMsal = async () => {
  try {
    devLog("Initializing MSAL...")
    await msalInstance.initialize()
    devLog("MSAL initialized successfully.")

    // Pulire le interazioni in corso all'avvio
    const storageKeys = Object.keys(sessionStorage)
    const interactionKeys = storageKeys.filter(
      (key) => key.startsWith("msal.interaction") || key.includes("interaction.status"),
    )

    if (interactionKeys.length > 0) {
      devLog("Cleaning up pending interactions at startup...")
      interactionKeys.forEach((key) => sessionStorage.removeItem(key))
    }
  } catch (error) {
    devError("MSAL initialization error:", error)
  }
}

export default msalInstance
